export default {
  set_id:(state, data) => state.id = data,
  set_name:(state, data) => state.names = data,
  set_email:(state, data) => state.email = data,
  set_rol:(state, data) => state.usr_role = data,
  set_empresa:(state, data) => state.com_id = data,
  set_password:(state, data) => state.password = data,
  set_passconf:(state, data) => state.passconf = data,
  set_numberId:(state, data) => state.numberId = data,
  com_id:(state, data) => state.com_id = data,
  trash_user(state){
    state.id=0,
    state.names='',
    state.numberId='',
    state.email='',
    state.password='',
    state.passconf='',
    state.email_verified_at='',
    state.language='es',
    state.usr_role=0,
    state.com_id=0,
    state.photoURL=require("@/assets/images/portrait/small/avatar-s-11.jpg")
  }
}


